var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_tool"},[_c('div',{staticClass:"switch_warp",class:{active: _vm.isOpen},on:{"click":function($event){return _vm.changePage()}}},[_c('div',{staticClass:"switch_bar bar_left"},[_vm._v("全景地图")]),_c('div',{staticClass:"switch_bar bar_right"},[_vm._v("数字画像")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }